import {
  UPLOAD_TRANSACTION_REQUEST,
  UPLOAD_TRANSACTION_REQUEST_FAILURE,
  UPLOAD_TRANSACTION_REQUEST_SUCCESS,
  UPLOAD_TRANSACTION_FETCH_REQUEST,
  UPLOAD_TRANSACTION_FETCH_REQUEST_SUCCESS,
  UPLOAD_TRANSACTION_FETCH_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const uploadTransactionReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case UPLOAD_TRANSACTION_REQUEST:
    case UPLOAD_TRANSACTION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case UPLOAD_TRANSACTION_REQUEST_SUCCESS:
    case UPLOAD_TRANSACTION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case UPLOAD_TRANSACTION_REQUEST_FAILURE:
    case UPLOAD_TRANSACTION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    // case NOTIFICATION_CLEAN_REQUEST:
    //   return Object.assign({}, state, {
    //     payload: [],
    //     loading: false,
    //     errors: {},
    //     CRUDErrors: {},
    //     pagination: {
    //       current: 0,
    //       pageSize: 0,
    //       total: 0,
    //       totalPage: 0,
    //     },
    //   });

    default:
      return state;
  }
};

export default uploadTransactionReducer;
